import WPAPI from 'wpapi';
const WORDPRESS_URL = 'https://fukudake3ea3cd852.wpcomstaging.com/wp-json';

export const wordpress = new WPAPI({
  endpoint: WORDPRESS_URL,
});
